import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useMemo } from 'react';

import { useAppSelector } from 'shared/lib/redux';

import { type TPledgeAutoFields, selectCarInfoDictionaries } from 'entities/pledgeAutoForm';
import { getPowerOptionsKey } from 'entities/pledgeAutoForm/lib/propertyKey';

export const useOptions = () => {
  const dictionaries = useAppSelector(selectCarInfoDictionaries);
  const { watch } = useFormContext<TPledgeAutoFields>();
  const brandId = watch('carBrand.value');
  const modelId = watch('carModel.value');
  const year = watch('carManufactureYear.value');

  return useMemo(
    () => ({
      brands: dictionaries.brands,
      models: dictionaries.models[brandId] ?? [],
      years: dictionaries.years[modelId] ?? [],
      powers: dictionaries.powers[getPowerOptionsKey({ brandId, modelId, year })] ?? [],
    }),
    [brandId, dictionaries.brands, dictionaries.models, dictionaries.powers, dictionaries.years, modelId, year],
  );
};
